import { render, staticRenderFns } from "./PurchaseRequestList.vue?vue&type=template&id=6032e536&scoped=true&"
import script from "./PurchaseRequestList.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequestList.vue?vue&type=style&index=0&id=6032e536&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6032e536",
  null
  
)

export default component.exports